export default "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?e044ed23c047e571c55071b6376337f9";